import {
  Button,
  Modal,
  Paper,
  Typography,
  Avatar,
  IconButton,
  Stack,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue, DeleteVector, PurpleClose, Trash } from 'Images';

interface IModal {
  isVisible: boolean;
  closeModal: () => void;
  deleteFile: () => void;
  fileName?: string;
  fileNames?: string[];
  title?: string;
}

export const DeleteModal2 = ({
  closeModal,
  deleteFile,
  isVisible,
  fileName,
  fileNames,
  title,
}: IModal) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.General).deleteModal;
  const isMany = fileNames && fileNames?.length > 1;

  const getTitle = () => {
    return isMany ? dictionary.many : dictionary.title;
  };

  return (
    <Modal
      open={isVisible}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          closeModal();
        }
      }}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(8, 30, 84, .8)' },
        },
      }}
    >
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '350px', sm: '770px' },
          height: { xs: '350px', sm: '486px' },
          backgroundColor: 'primary.shade_100',
          borderRadius: '16px',
        }}
        component='fieldset'
      >
        <legend>
          {Dictionary[DICTIONARY.Requests].deleteFile.deleteModalExitAlt}
        </legend>
        <IconButton
          onClick={closeModal}
          sx={{
            position: 'absolute',
            top: isDesktop ? '24px' : '15px',
            left: isDesktop ? '19px' : '15px',
          }}
        >
          <Avatar
            src={PurpleClose}
            alt={Dictionary[DICTIONARY.Requests].deleteFile.deleteModalExitAlt}
          />
        </IconButton>
        <Stack
          component='fieldset'
          sx={{
            justifyContent: 'center',
            gap: !isDesktop && isMany ? '24px' : '56px',
            height: '100%',
          }}
        >
          <legend>{`${getTitle().replace('?', '')} ${
            fileName ?? fileNames?.map((name) => name).join(', ')
          }?`}</legend>
          <Stack
            sx={{
              alignItems: 'center',
              gap: '24px',
            }}
          >
            <Avatar
              src={DeleteVector}
              alt={''}
              sx={{ width: '160px', height: '142px' }}
            />
            <Stack
              sx={{
                alignItems: 'center',
                gap: '18px',
              }}
            >
              <Typography
                sx={{
                  fontSize: { sm: '32px' },
                  fontWeight: { sm: 700 },
                }}
              >
                {title ?? getTitle()}
              </Typography>
              <Stack
                sx={{
                  fontSize: { xs: '28px', sm: '28px' },
                  fontWeight: { xs: 400, sm: 400 },
                }}
              >
                <Stack
                  sx={{
                    maxHeight: isDesktop ? '150px' : '40px',
                    overflowY: isMany ? 'auto' : 'hidden',
                    alignItems: 'center',
                  }}
                >
                  {fileName ? (
                    <Typography>{fileName}</Typography>
                  ) : (
                    fileNames?.map((name, index) => (
                      <Typography key={index}>{name}</Typography>
                    ))
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            direction={'row'}
            sx={{
              justifyContent: 'center',
              gap: isDesktop ? '40px' : '10px',
              paddingX: isDesktop ? '0' : '10px',
            }}
          >
            <Button
              onClick={closeModal}
              sx={{
                width: '154',
                height: '46px',
                padding: '12px 24px',
                gap: '4px',
                backgroundColor: '#fff',
                border: '1px solid',
                borderColor: '#3A6EEC',
                borderRadius: '100px',
                boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
                '&:hover': {
                  backgroundColor: '#fff',
                },
              }}
            >
              <Avatar
                src={ArrowBackBlue}
                alt={''}
                sx={{ width: '20px', height: '20px', rotate: '180deg' }}
              />
              <Typography>{dictionary.cancel}</Typography>
            </Button>
            <Button
              onClick={deleteFile}
              sx={{
                backgroundColor: '#3A6EEC',
                boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
                borderRadius: '100px',
                padding: '12px 24px',
                width: '154px',
                height: '46px',
                gap: '4px',
                '&:hover': {
                  backgroundColor: '#3A6EEC',
                },
              }}
            >
              <Avatar src={Trash} alt={''} sx={{ height: '0', width: '0' }} />
              <Typography
                sx={{ color: '#fff', fontWeight: 700, fontSize: '18px' }}
              >
                {dictionary.confirm}
              </Typography>
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
};
